<!--
 * @Author: your name
 * @Date: 2024-10-11 15:27:05
 * @LastEditTime: 2025-02-19 11:12:01
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \carlife_h5\src\App.vue
-->
<template>
  <div class="html">
    <!--中间内容-->
    <transition name="fade" v-if="isToken">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Api from "./request/api";

import { postAuthorize, isH5Flag } from "./request/http";

export default {
  name: "app",
  data() {
    return {
      //获取touken
      isToken: false
    };
  },
  components: {},
  created() {
    // localStorage.clear();
    localStorage.removeItem("authInfo");
    localStorage.removeItem("selectId");
    if (isH5Flag()){ // 判断来源跳过校验
        this.isToken = true
        return;
    };
    this.setToken();
  },
  destroyed() {},
  methods: {
    /**
     * 授权登录
     */
    async setToken() {
      await postAuthorize();
      this.isToken = true;
    }
  }
};
</script>
<style lang="less">
.van-popover--dark {
  left: 0 !important;
  .van-popover__arrow {
    left: 35px !important;
  }
  .van-popover__content {
    width: calc(100% - 40px);
    margin-left: 20px;
  }
}
</style>
<style >
.van-checkbox__icon--checked .van-icon {
  background-color: #47c484 !important;
  border-color: #47c484 !important;
}
@import "./less/reset.less";
html,
body {
  background: #f2f2f2;
  /* height: 100%; */
}
:root {
  --statusHeight: 84px;
}
.html {
  max-width: 100%;
  overflow-x: hidden;
  margin: 0 auto;
  height: calc(100%);
  /* padding-top: 45px; */
}
.fade-enter-active,
.fade-leave-active {
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue